export default __webpack_public_path__ + "static/media/GreiffPremiumRf.c17007f2.jpeg";